export default {
  forgot_password_submit: {
    title: '重置密码',
    submit_complete: '发送成功',
    password_reset: '已重置密码。',
  },
}
